module.exports = __webpack_public_path__ + "static/media/arrow.d7c48e6a.svg";